import { render } from "./PageFormDokumenPendukung.vue?vue&type=template&id=03ae42f2"
import script from "./PageFormDokumenPendukung.vue?vue&type=script&lang=js"
export * from "./PageFormDokumenPendukung.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__